import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController } from 'ionic-angular';
import 'rxjs/add/operator/map';

import { Events } from 'ionic-angular';

import * as L from "leaflet";
// import * as esri from 'esri-leaflet';
import 'leaflet-timedimension';

@Injectable()


export class CommonProvider {

    public requestPayload: any = {}
    public toast: any;
    public alert: any;
    
    public map: any;
    public marker: any;
    public timeDimensionControl: any;
    public wmsSimLayer: any
    public simulationLayer: any
    public simulationTimeLayer: any
    public colorbarEnvUrl: any = null
    public colorbarOilUrl: any = null
    public player: any
    
    // public env_fileds_path: string = '/var/www/html/ov-dev/ov-backend/mapfiles/';
    public env_fileds_url: string = 'https://ov-dev.cmcc-opa.eu/cgi-bin/mapserv?';

    // public sim_results_url:string = 'http://193.204.199.162:8888/cgi-bin/mapserv?';
    public sim_results_url: string = 'https://wms-dev.cmcc-opa.eu/cache/mapsrvn8?';
    public proxy_url: string = 'https://wms-dev.cmcc-opa.eu/cache/DSS/WITOIL/proxy.php';
    // sim_archive_url
    // public sim_archive_url: string = 'http://localhost:8100/wsdb';
    public sim_archive_url: string = 'https://admin:Cmcc2018@couchdb.witoil.cmcc-opa.eu/wsdb';
    public userDB = null;

    // public geobridge_url: string = 'http://195.60.133.101/geobridge';
    public geobridge_url: string = 'https://ws.cmcc-opa.eu/geobridge';
    public is_ocean: boolean = true;

    public curr_date: any;
    public env_fields_array: any = {};
    public curr_Ov0: boolean = true
    public curr_env_field: any = {};
    public curr_simulation: any
    // public curr_env_field_idx: number = 0;


    public payload = {
        "sim_name": "",
        "notes": "",
        "start_lat": "",
        "start_lon": "",
        "model": "",
        "wind": [],
        "sim_length": "",
        "day": "",
        "month": "",
        "year": "",
        "hour": "",
        "minutes": "",
        "lat_degree": "",
        "lat_minutes": "",
        "lon_degree": "",
        "lon_minutes": "",
        "spillType": 0,
        "duration": "0001",
        "spillrate": "",
        "oil": "",
        "oiltype":"",
        "var_02": "",
        "var_03": "",
        "var_10": "",
        "var_14": "",
        "var_19": "",
        "var_29": "",
        "var_39": "",
        "plotStep": 0,
        "selector": "",
        "uncert_type": "",
        "hex": "",
        "uncert_radius": "",
    }

    public visualization_options = {
        "curr_coord_unit": "",
        "curr_uncert_display": "",
        "curr_uncert_results": "",
        "curr_simulation": "",
        "curr_env_field": "",
        "curr_env_field_idx": "",
        "curr_Ov0": "",
        "curr_oil0": "",
        "curr_sim_res_totaloil": true,
        "curr_sim_res_beached": false,
        "curr_sim_res_env": 'nofield'
    }

    public simulations: any = [
        {
        	"UUID": "",
        	"creation_date": "",
        	"dss": "",
        	"payload": {
        		"sim_name": "",
        		"notes": "",
        		"start_lat": "",
        		"start_lon": "",
        		"model": "",
        		"wind": ""
        	},
        	"sim_id": "99999759",
        	"status": "",
        	"status_message": "",
        	"update_date": "",
        	"_id": "",
        	"_rev": ""
        }
    ]
    
    


    // *************************************************************************************
    //  
    // *************************************************************************************
    constructor(
        public http: HttpClient,
        public loadingCtrl: LoadingController,
        public toastController: ToastController,
        public alertController: AlertController,
        public events: Events,
    ) {

    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    checkLand(latlng: any) {
        return new Promise(resolve => {
            let lat = latlng.lat
            let lng = latlng.lng
            this.http.get(this.geobridge_url+'/?callback=cb&lat='+lat+'&lon='+lng+'&_='+Date.now(), {responseType: 'text'}).subscribe(
                data => {
                    let tmp = JSON.stringify(data).replace('cb(', '').replace(')', '')
                    data = JSON.parse(tmp)
                    console.log("data",data)
                    resolve(data);
                },
                err => console.error(err),
            );
        });
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    getModelFromWS(latlng: any) {
        return new Promise(resolve => {
            let lat = latlng.lat
            let lng = latlng.lng
            if(lat && lng) {
                this.http.get('assets/data/oilbaseName.json?lat='+lat+'&lng='+lng).subscribe(
                    data => {
                        data = 'GLOB'
                        resolve(data);
                    },
                    err => console.error(err),
                    // () => console.log('getOilByName completed')
                );
            } else {
                this.showAlert('ERROR','Wrong coordinates','Check latitude and longitude!')
            }
        });
    }
    
    
    // *************************************************************************************
    //  
    // *************************************************************************************
    getOilsByName() {
        return new Promise(resolve => {
            this.http.get('assets/data/oilbaseName.json').subscribe(
                data => {
                    resolve(data);
                },
                err => console.error(err),
                // () => console.log('getOilByName completed')
            );
        });
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    getOilsByAPI() {
        return new Promise(resolve => {
            this.http.get('assets/data/oilbaseApi.json').subscribe(
                data => {
                    resolve(data);
                },
                err => console.error(err),
                // () => console.log('getOilsByAPI completed')
            );
        });
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    setMarker(latlng) {
        if (this.marker != undefined) {
            this.map.removeLayer(this.marker);
        };

        var myIcon = L.icon({
            iconUrl: 'assets/css/images/marker-icon.png',
            iconSize: [16,24],
            iconAnchor: [8, 24],
            popupAnchor: [0, -24],
            shadowUrl: 'assets/css/images/marker-shadow.png',
            shadowSize: [17, 25],
            shadowAnchor: [5, 25]
        });
        
        this.marker = new L.marker(latlng,
            {
                draggable: 'true',
                autoPan: 'true',
                interactive: 'true',
            }
        ).addTo(this.map);
        
        this.marker.setIcon(myIcon);

        let position = this.marker.getLatLng();
        this.marker.bindPopup(position.lat.toFixed(5) + ' ' + position.lng.toFixed(5))//.openPopup()
        this.marker.on('drag', () => {
            let position = this.marker.getLatLng();
            // console.log("position: ", position )
            this.events.publish('marker:drag', position);
            this.marker.openPopup();
            this.marker.bindPopup(position.lat.toFixed(5) + ' ' + position.lng.toFixed(5)).update();
        });
        this.marker.on('dragend', () => {
            let position = this.marker.getLatLng();
            // this.marker.closePopup();
            // console.log("position: ", position )
            this.events.publish('marker:dragend', position);
        });
        this.marker.on('popupclose', function (e) {
            // console.log("popupclose marker: ", this, e); 
            // e.sourceTarget._map.removeLayer(this)
        })
    }
    // *************************************************************************************
    //  
    // *************************************************************************************
    set_env_fields_array(curr_UTC_date: any): Promise<any> {

        return new Promise(resolve => {

            let year = this.pad(curr_UTC_date.getUTCFullYear(), 2, 0)
            let month = this.pad(curr_UTC_date.getUTCMonth() + 1, 2, 0)
            let day = this.pad(curr_UTC_date.getUTCDate(), 2, 0)
            let hour = this.pad(curr_UTC_date.getUTCHours(), 2, 0)
            let minute = "00"

            let fcst_date = year + month + day;
            let fcst_time = hour + minute;
            console.log("fcst_date----> ", fcst_date);
            console.log("fcst_time----> ", fcst_time);
            let prod_date = year + month + this.pad(parseInt(day) - 1, 2, 0)

            this.env_fields_array = [
                {
                    "value": "-1",
                    "label": 'NO DATA',
                    "disabled": true,
                    "layer": '',
                    "map": ''
                },
                {
                    "value": "0",
                    "label": 'temperature-key',
                    "disabled": false,
                    "layer": 'MEDSEA_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Temperature',
                    "map": '/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Temperature_' + fcst_date + '.map'
                },
                {
                    "value": "1",
                    "label": 'wind-key',
                    "disabled": false,
                    "layer": 'GLO_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wind,GLO_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wind-Direction',
                    "map": '/var/www/html/ov/marine-eo-2/backend/mapfiles/GLO_Wind_' + fcst_date + '.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/GLO_Wind-Direction_' + fcst_date + '.map'
                },
                {
                    "value": "2",
                    "label": 'wave-height-key',
                    "disabled": false,
                    "layer": 'MED_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wave-Height,MED_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wave-Direction',
                    "map": '/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Height_' + fcst_date + '.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Direction_' + fcst_date + '.map'
                },
                {
                    "value": "3",
                    "label": 'wave-period-key',
                    "disabled": false,
                    "layer": 'MED_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wave-Period,MED_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Wave-Direction',
                    "map": '/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Period_' + fcst_date + '.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Direction_' + fcst_date + '.map'
                },
                {
                    "value": "4",
                    "label": 'surfaceCurr-key',
                    "disabled": false,
                    "layer": 'MEDSEA_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Currents,MEDSEA_' + prod_date + '_' + fcst_date + '_' + fcst_time + '_0_Currents-Direction',
                    "map": '/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Currents_' + fcst_date + '.map,/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Currents-Direction_' + fcst_date + '.map'
                }
            ]
            //console.log("this.env_fields_array --- ", this.env_fields_array)

            resolve(this.env_fields_array);

        });

    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    set_curr_env_field(curr_env_field_idx: number) {
        return new Promise(resolve => {
            this.curr_env_field = this.env_fields_array[curr_env_field_idx]
            // console.log("this.curr_env_field --->>> ", this.curr_env_field)

            this.events.publish('map:setlayer', this.curr_env_field.layer, this.curr_env_field.map);
            resolve(this.curr_env_field);
        });
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    sendGetRequest(payload: any) {

        return new Promise((resolve, reject) => {
            let url = "http://localhost:8100/api/jsonws/dss-portlet.request/receiveJsonFromUI"

            let headers = new HttpHeaders();
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');

            this.http.get(url, { headers: headers }).subscribe(
                data => {
                    resolve(data);
                },
                err => {
                    console.error("ERROR in sendRequest: ", err)
                    reject("ERRORE");
                }
            );
        });
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    sendPostRequest(payload: any) {

        return new Promise((resolve, reject) => {
            // let url = "http://localhost:8100/api/jsonws/dss-portlet.request/receiveJsonFromUI"
            let url = "https://wms-dev.cmcc-opa.eu/cache/DSS/WITOIL/curl.php"

            let headers = new HttpHeaders();
            // headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            // headers.append('Access-Control-Allow-Origin' , '*');
            // headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
            // headers.append('Cookie','TEST=test')
            // headers.append('JSESSIONID','1C6430CD607BE71CBB771F16DE097683')
            // document.cookie = "SERVERID=s1";
            // document.cookie = "COOKIE_SUPPORT=true";
            // document.cookie = "LOGIN=67697573657070652e7475727269736940636d63632e6974";
            // document.cookie = "COMPANY_ID=10154";
            // document.cookie = "ID=443663454c6e7a777871493d";
            // document.cookie = "USER_UUID=iwNdV+/NwiXNxTZ9l9Yyd+x1r+1Tfu5GQ+XWYxNw+SY=";
            // document.cookie = "PASSWORD=724d46396c4e4e6f6e35524435645a6a453344354a673d3d";
            // document.cookie = "JSESSIONID=1DE9CCCBD5BC965D2DF5B53A8999AEEE";

            let formData = new FormData();
            formData.append('UUID', this.userDB);
            formData.append('payload', JSON.stringify(payload));

            this.http.post(url, formData, { headers: headers }).subscribe(
                data => {
                    resolve(data);
                },
                err => {
                    console.error("ERROR in sendRequest: ", err)
                    reject(err);
                }
            );
        });
    }
    

    // *************************************************************************************
    //  Visualizza toast
    // *************************************************************************************
    showToast(msg: string) {
        this.toast = this.toastController.create({
            message: msg,
            duration: 1500,
            position: 'middle',
        })
        this.toast.present();
    }

    // *************************************************************************************
    //  Visualizza Alert
    // *************************************************************************************
    async showAlert(title: string, subTitle: string, msg: string) {
    
        this.alert = this.alertController.create({
            title: title,
            subTitle: subTitle,
            message: msg,
            buttons: ['OK']
        });
        this.alert.present();
    }

    // *************************************************************************************
    //  
    // *************************************************************************************
    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }


}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts